/** Presentation only. No account state, tracking, storage or provider requests. */
export function initialisePublicHeroMotion(root: HTMLElement): () => void {
  const hero = root.querySelector<HTMLElement>(".story-hero");
  const video = root.querySelector<HTMLVideoElement>(".hero-film");
  const toggle = root.querySelector<HTMLButtonElement>(".motion-toggle");
  if (!hero || !video || !toggle) return () => {};
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
  const desktop = window.matchMedia("(min-width: 1024px)");
  let pausedByVisitor = false;
  let disposed = false;
  const updateMotion = () => {
    const paused = pausedByVisitor || reduced.matches || document.hidden;
    if (paused && hero.dataset.paused !== "true") {
      const scenes = Array.from(root.querySelectorAll<HTMLElement>(".hero-scene"));
      const visible = scenes.reduce<HTMLElement | null>((best, scene) => !best || Number(getComputedStyle(scene).opacity) > Number(getComputedStyle(best).opacity) ? scene : best, null);
      scenes.forEach(scene => scene.classList.toggle("paused-scene", scene === visible));
    }
    hero.dataset.paused = String(paused);
    toggle.textContent = paused ? "Play background motion" : "Pause background motion";
    toggle.setAttribute("aria-pressed", String(paused));
    toggle.hidden = reduced.matches;
    if (paused || !desktop.matches) video.pause();
    else {
      const sources = Array.from(video.querySelectorAll("source"));
      if (sources[0] && !sources[0].getAttribute("src")) {
        sources.forEach(source => { if (source.dataset.src) source.src = source.dataset.src; });
        video.load();
      }
      void video.play().catch(() => { if (!disposed) hero.classList.remove("film-playing"); });
    }
  };
  const toggleMotion = () => {
    if (reduced.matches) return;
    pausedByVisitor = !pausedByVisitor;
    updateMotion();
  };
  const playing = () => { if (!disposed) hero.classList.add("film-playing"); };
  const failed = () => hero.classList.remove("film-playing");
  hero.classList.add("motion-ready");
  toggle.addEventListener("click", toggleMotion);
  video.addEventListener("playing", playing);
  video.addEventListener("error", failed);
  reduced.addEventListener("change", updateMotion);
  desktop.addEventListener("change", updateMotion);
  document.addEventListener("visibilitychange", updateMotion);
  updateMotion();
  return () => {
    disposed = true;
    toggle.removeEventListener("click", toggleMotion);
    video.removeEventListener("playing", playing);
    video.removeEventListener("error", failed);
    reduced.removeEventListener("change", updateMotion);
    desktop.removeEventListener("change", updateMotion);
    document.removeEventListener("visibilitychange", updateMotion);
    video.pause();
    hero.classList.remove("motion-ready", "film-playing");
  };
}
